import axios from '@/utils/axios'
import {getBackendByRole} from '@/utils/role'
import {business} from '@/api/common'

/**
 * 登出
 * @returns {AxiosPromise}
 */
export const loginOut = () => {
  return axios({
    url: `${getBackendByRole()}/user/loginOut`,
    method: 'post',
    headers: {
      NotNeedAuthorization: true
    }
  })
}

/**
 * 修改管理人员密码
 * @param form
 * @returns {AxiosPromise}
 */
export const modifyPassword = form => {
  return axios({
    url: `${getBackendByRole()}/user/modifyPassword`,
    method: 'post',
    data: form
  })
}

/**
 * 获取当前用户是否有无登录密码
 * @returns {AxiosPromise}
 */
export const verifyCurrentUserPwdExistState = () => {
  return axios({
    url: `${business}/user/verifyCurrentUserPwdExistState`,
    method: 'get'
  })
}

/**
 * 获取 云诊365APP 扫码登录 二维码
 * @param form
 * @returns {AxiosPromise}
 */
export const getSCLoginCode = role => {
  return axios({
    url: `${getBackendByRole()}/user/pc_session?role=${role}`,
    method: 'post'
  })
}

/**
 * app扫码后确认
 */
export const sCLogin = params => {
  return axios({
    url: `${getBackendByRole()}/user/session_login`,
    headers: {
      NotNeedAuthorization: true,
      NotNeedShowErrorMessage: true
    },
    method: 'post',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/common/auth/authUser.js